let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lVjUX")).then(() => parcelRequire('43YGL'));